// extracted by mini-css-extract-plugin
export default {"header":"_2iYi","headerName":"_3lf7","sourceBadge":"E8-z"};